import { TAccentLevels } from '../types';

// GENERATED BY CLAUDE BTW

export const generateAccentMap = (
  beatsPerBar: number,
  beatValue: number,
  subdivisionDenominator: number = 16
) => {
  const subdivisionsPerBeat = subdivisionDenominator / beatValue;
  const totalSubdivisions = beatsPerBar * subdivisionsPerBeat;

  return Array.from({ length: totalSubdivisions }, (_, i) => {
    const beatPosition = Math.floor(i / subdivisionsPerBeat);
    const subdivisionPosition = i % subdivisionsPerBeat;

    // Downbeat is always strongest
    if (i === 0) return 3;

    // Compound meters (beat unit = dotted note, e.g., 6/8, 9/8, 12/8)
    if (beatValue === 8 && beatsPerBar % 3 === 0) {
      const groupPosition = Math.floor(beatPosition / 3);

      // Secondary accent on groups after the first
      if (beatPosition % 3 === 0 && groupPosition > 0) return 2;

      // Beat accents within groups
      if (subdivisionPosition === 0) return 1;

      return 0;
    }

    // Irregular compound meters (5/8, 7/8, etc.)
    if (beatValue === 8 && beatsPerBar % 3 !== 0) {
      // 5/8: typically grouped as 3+2 or 2+3
      if (beatsPerBar === 5) {
        if (beatPosition === 3) return 2; // 3+2 grouping
        if (subdivisionPosition === 0) return 1;
        return 0;
      }

      // 7/8: typically grouped as 2+2+3 or 3+2+2
      if (beatsPerBar === 7) {
        if (beatPosition === 2 || beatPosition === 4) return 2; // 2+2+3 grouping
        if (subdivisionPosition === 0) return 1;
        return 0;
      }

      // Default: alternate strong/weak
      if (subdivisionPosition === 0) return beatPosition % 2 === 0 ? 2 : 1;
      return 0;
    }

    // Simple meters (2/4, 3/4, 4/4, 5/4, etc.)
    if (beatValue === 4) {
      // Standard subdivision accents
      if (subdivisionPosition === 0) {
        // Beat 3 in 4/4 gets secondary accent
        if (beatsPerBar === 4 && beatPosition === 2) return 2;
        // Beat 4 in 5/4 gets secondary accent (3+2 grouping)
        if (beatsPerBar === 5 && beatPosition === 3) return 2;
        // Beat 4 in 6/4 gets secondary accent
        if (beatsPerBar === 6 && beatPosition === 3) return 2;
        // Beat 3 in 7/4 and beat 5 in 7/4 (3+2+2 or 2+2+3)
        if (beatsPerBar === 7 && (beatPosition === 2 || beatPosition === 4))
          return 2;

        // All other downbeats
        return 2;
      }

      // Eighth note in the middle of the beat (the "and")
      if (subdivisionPosition === 2) return 1;

      return 0;
    }

    // Half note beat unit (2/2, 3/2, 4/2)
    if (beatValue === 2) {
      if (subdivisionPosition === 0) {
        // Beat 3 in 4/2 gets secondary accent
        if (beatsPerBar === 4 && beatPosition === 2) return 2;
        return 2;
      }

      // Quarter note subdivision
      if (subdivisionPosition === 4) return 1;

      return 0;
    }

    // Sixteenth note beat unit (rare, but possible)
    if (beatValue === 16) {
      return subdivisionPosition === 0 ? 2 : 0;
    }

    // Default fallback
    return subdivisionPosition === 0 ? 2 : 0;
  }) as TAccentLevels[];
};
